import jQuery from "jquery";

import { getLanguages } from "./util.js";
import { isEqual } from "lodash-es";
import { adjustDailyValueHeight } from "./layout.js";
import { showProperAllergens, showProperIngredients } from "./sections.js";

const $ = jQuery;

export function showLanguages() {
  // Only CA labels have multi-language features
  const languages = getLanguages();

  const englishSelectors = [".bilingual-english", ".english-only"];
  const frenchSelectors = [".bilingual-french", ".french-only"];

  const bilingualSelectors = [".bilingual-separator", ".bilingual-only"];
  const onlySelectors = [".english-only", ".french-only"];

  const hideSelectors = (selectors) =>
    document.querySelectorAll(selectors).forEach((e) => e.classList.add("is-hidden"));
  const showSelectors = (selectors) =>
    document.querySelectorAll(selectors).forEach((e) => e.classList.remove("is-hidden"));

  // Always put showSelectors before hideSelectors since there are overlaps in the classes
  if (isEqual(languages, ["en"])) {
    showSelectors(englishSelectors);

    hideSelectors(frenchSelectors);
    hideSelectors(bilingualSelectors);
  } else if (isEqual(languages, ["fr"])) {
    showSelectors(frenchSelectors);

    hideSelectors(englishSelectors);
    hideSelectors(bilingualSelectors);
  } else {
    // ["en", "fr"] or ["fr", "en"]
    showSelectors(englishSelectors);
    showSelectors(frenchSelectors);
    showSelectors(bilingualSelectors);

    hideSelectors(onlySelectors);

    // Reverse language as necessary
    const frenchFirst = document.querySelector("#reverse-language-toggle").checked;
    $(".bilingual").each(function () {
      const english = $(this).find(".bilingual-english");
      const french = $(this).find(".bilingual-french");

      if (english.length == 0 || french.length == 0) {
        console.error("Expected multiple languages in bilingual block, got one");
      }

      const englishCurrentlyFirst = english.index() < french.index();
      if ((frenchFirst && englishCurrentlyFirst) || (!frenchFirst && !englishCurrentlyFirst)) {
        // switch french and english elements, only if necessary
        const englishClone = english.clone().insertAfter(english);
        english.detach().insertAfter(french);
        french.detach().insertAfter(englishClone);
        englishClone.remove();
      }
    });
  }

  showProperIngredients();
  showProperAllergens();
  adjustDailyValueHeight();
}
